import "./OurMarqueeDeployments.css";

const OurMarqueeDeployments = () => {
  return (
    <div>
      <div className="hero_img deploy_mobile_img">
      <div className="hero_title">Our Marquee Deployments</div>
      <img src="/assets/projects.jpg" alt="" />

      </div>
      <div className="deployp_container">
        <div className="deployp_div1">
          <h2>Metros & Airports</h2>
          <p>Presence in leading metros and airports across the country</p>
        </div>
        <div className="deployimgcontainer">
          <div className="deployp_div2">
            <div className="deployp_div21">
              <img src="/assets/delployment/deployimg2.jpg" alt="" />
              <span>Delhi Metro</span>
            </div>
            <div className="deployp_div21">
              <img src="/assets/delployment/deployimg3.jpg" alt="" />
              <span>Chennai Metro</span>
            </div>
            <div className="deployp_div21">
              <img src="/assets/delployment/deployimg4.jpg" alt="" />
              <span>Lucknow Metro</span>
            </div>
          </div>
          <div className="deployp_div2">
            <div className="deployp_div21">
              <img src="/assets/delployment/deployimg5.jpg" alt="" />
              <span>Mumbai Metro</span>
            </div>
            <div className="deployp_div21">
              <img src="/assets/delployment/deployimg6.jpg" alt="" />
              <span>Kolkata Metro</span>
            </div>
          </div>
          <div className="deployp_div2">
            <div className="deployp_div21">
              <img src="/assets/delployment/deployimg7.jpg" alt="" />
              <span>Goa Airport</span>
            </div>
            <div className="deployp_div21">
              <img src="/assets/delployment/deployimg8.jpg" alt="" />
              <span>Srinagar Airport</span>
            </div>
            <div className="deployp_div21">
              <img src="/assets/delployment/deployimg9.jpg" alt="" />
              <span>Kannur Airport</span>
            </div>
          </div>
          <div className="deployp_div2">
            <div className="deployp_div21">
              <img src="/assets/delployment/deployimg10.jpg" alt="" />
              <span>Amritsar Airport</span>
            </div>
            <div className="deployp_div21">
              <img src="/assets/delployment/deployimg11.jpg" alt="" />
              <span>Udaipur Airport</span>
            </div>
          </div>
        </div>

        <div className="deployimgcontainer">
          <div className="deployp_div3 ">
            <h2>Retail and Institutional</h2>
            <div className="deployp_div2">
              <div className="deployp_div21">
                <img src="/assets/delployment/deployimg12.jpg" alt="" />
                <span>DLF Mall of India, Noida</span>
              </div>
              <div className="deployp_div21">
                <img src="/assets/delployment/deployimg13.jpg" alt="" />
                <span>DLF Cyberpark, Gurugram</span>
              </div>
              <div className="deployp_div21">
                <img src="/assets/delployment/deployimg14.jpg" alt="" />
                <span>Serum Institute, Pune</span>
              </div>
            </div>

            <div className="deployp_div2">
              <div className="deployp_div21">
                <img src="/assets/delployment/deployimg15.jpg" alt="" />
                <span>AIIMS Hospital, Delhi</span>
              </div>
              <div className="deployp_div21">
                <img src="/assets/delployment/deployimg16.jpg" alt="" />
                <span>Atal Tunnel, Himachal Pradesh</span>
              </div>
              <div className="deployp_div21">
                <img src="/assets/delployment/deployimg17.jpg" alt="" />
                <span>IIT, Delhi</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};
export default OurMarqueeDeployments;
